export const DEFAULT_THROTTLE_DELAY_MS = 1200;
const queue = [];
let processing = false;
let currentThrottleDelay = DEFAULT_THROTTLE_DELAY_MS;
function processNext() {
  const task = queue.shift();
  if (!task) {
    processing = false;
    return;
  }
  task.fn().then(task.resolve).catch(task.reject);
  setTimeout(processNext, currentThrottleDelay);
}
export const enqueueRequest = (fn, throttleDelayMs) => {
  if (throttleDelayMs !== undefined) {
    currentThrottleDelay = throttleDelayMs;
  }
  return new Promise((resolve, reject) => {
    queue.push({
      fn,
      reject,
      resolve
    });
    if (!processing) {
      processing = true;
      processNext();
    }
  });
};
export const clearRequestQueue = () => {
  queue.length = 0;
  processing = false;
};
export const getQueueLength = () => queue.length;
//# sourceMappingURL=request-queue.js.map